import { render, staticRenderFns } from "./interactionModule.vue?vue&type=template&id=544de152&scoped=true&"
import script from "./interactionModule.vue?vue&type=script&lang=js&"
export * from "./interactionModule.vue?vue&type=script&lang=js&"
import style0 from "./interactionModule.vue?vue&type=style&index=0&id=544de152&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544de152",
  null
  
)

export default component.exports